import React from "react";
import Link from "next/link";
import { User } from "../../entities";
import closeIcon from "../../new-images/closeicon.svg";
import newBadgeImg from "../../new-images/profile/new-badge.svg";
import badgeMobileBg from '../../new-images/profile/new-badge-back-down.svg';
import styles from './styles.module.scss';

interface IProps {
  currentUser: User;
}

const GetBadgeComponent: React.FC<IProps> = ({ currentUser }) => {
  const [visible, setVisible] = React.useState(false);
  const [isPin, setIsPin] = React.useState(false);

  React.useEffect(() => {
    const storedValue = localStorage.getItem("modalVisible");
    if (storedValue) {
      setVisible(JSON.parse(storedValue));
    } else {
      setVisible(true)
    }
  }, []);

  // React.useEffect(() => {
  //   setIsPin(currentUser?.is_pin_20);
  // }, [currentUser?.id]);

  const handleClose = () => {
    setVisible(false);
    localStorage.setItem("modalVisible", JSON.stringify(false));
  };

  return (
    visible && (
      <div className={`container ${styles.Badge}`}>
        <div className={styles.BadgeContent}>
          <img src={newBadgeImg} alt="бейдж" />
          <div className={styles.BadgeContent_text}>
            <p className={styles.BadgeContent_text__title}>Сувениры для <span>доноров</span></p>
            <p className={styles.BadgeContent_text__info}>Участвуйте в мотивационной программе и получите бесплатный значок и браслет от DonorSearch</p>
            <a href={'/souvenir'} target="_blank">Узнать о программе</a>
          </div>
        </div>
        <div className={styles.BadgeButtons}>
          <Link href="/souvenir">
            <a
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className={styles.button}>
                Узнать о программе
              </div>
            </a>
          </Link>
          <button className={styles.close} onClick={handleClose}>
            <img src={closeIcon} alt="close"></img>
          </button>
        </div>
        <img src={badgeMobileBg} className={styles.BadgeBg}></img>
      </div>
    )
  );
};

export default GetBadgeComponent;
